import { ONBOARDING_AB_TEST_VERSIONS, WIDGET_TYPES } from 'enums/configuration';

export function handleBucketLogic(widgetType) {
  // We always want to use interactive when widget type is CHAT
  // if widget type is SELF_SERVICE, we return form to ensure
  // everything is working correctly.
  // Clubhouse to clean this up
  // https://app.clubhouse.io/gladly/story/61578/add-ability-for-sidekick-configuration-to-set-startpage
  if (widgetType === WIDGET_TYPES.CHAT) {
    return ONBOARDING_AB_TEST_VERSIONS.interactive;
  }

  return ONBOARDING_AB_TEST_VERSIONS.form;
}

// Check for alternate bucket. Differentiating between A/B gives more description in analysis vs a bool
export function isAlternateBucket(bucket) {
  return bucket === ONBOARDING_AB_TEST_VERSIONS.interactive;
}
